import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-store-page" }
const _hoisted_2 = { class: "footer-disclaimer" }

import { useI18n } from 'vue-i18n';
import StatusBar from './components/StatusBar.vue';
import TopNav from './components/TopNav.vue';
import AppHeader from './components/AppHeader.vue';
import StatsRow from './components/StatsRow.vue';
import ScreenshotsGallery from './components/ScreenshotsGallery.vue';
import DescriptionSection from './components/DescriptionSection.vue';
import RatingsReviews from './components/RatingsReviews.vue';
import WhatsNew from './components/WhatsNew.vue';
import AppPrivacy from './components/AppPrivacy.vue';
import AccessibilitySection from './components/AccessibilitySection.vue';
import InformationSection from './components/InformationSection.vue';
import MoreByDeveloper from './components/MoreByDeveloper.vue';
import YouMightAlsoLike from './components/YouMightAlsoLike.vue';
import TabBar from './components/TabBar.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'AppStoreView',
  setup(__props) {

const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(StatusBar),
    _createVNode(AppHeader),
    _createVNode(StatsRow),
    _createVNode(ScreenshotsGallery),
    _createVNode(DescriptionSection),
    _createVNode(RatingsReviews),
    _createVNode(WhatsNew),
    _createVNode(AppPrivacy),
    _createVNode(AccessibilitySection),
    _createVNode(InformationSection),
    _createVNode(YouMightAlsoLike),
    _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(t)('appStore.footerDisclaimer')), 1)
  ]))
}
}

})